import { Action } from '@ngrx/store';
import { ContractOP, ProductOP, RmsContractBalance } from '@cemex-core/cmx-api';

export enum AdtContractActionTypes {
    LOAD_AVAILABLE_CONTRACTS = '[ADT Contract] Load Available Contracts',
    FETCH_CONTRACT_BALANCES = '[ADT Contract] Fetch Balance Of Contracts Available',
    LOAD_CONTRACT_BALANCES = '[ADT Contract] Load Balance Of Contracts Available',
    LOAD_CONTRACT_SELECTED = '[ADT Contract] Load Contract Selected',
    RESET = '[ADT Contract] Reset',
}

/**
 * Fetch balance of all contracts available of the product
 */
export class FetchBalanceContracts implements Action {
    readonly type = AdtContractActionTypes.FETCH_CONTRACT_BALANCES;

    constructor(public payload: ProductOP) { }
}

/**
 * Loads balance of each contract of the product
 */
export class LoadContractBalancesAction implements Action {
    readonly type = AdtContractActionTypes.LOAD_CONTRACT_BALANCES;

    constructor(
        public payload: {
            [productCode: string]: RmsContractBalance[];
        },
    ) { }
}

/**
 * Load contract selected
 */
export class LoadContractSelectedAction implements Action {
    readonly type = AdtContractActionTypes.LOAD_CONTRACT_SELECTED;

    constructor(public payload: ContractOP) { }
}

/**
 * Loads available contracts of the product
 */
export class LoadProductContracts implements Action {
    readonly type = AdtContractActionTypes.LOAD_AVAILABLE_CONTRACTS;

    constructor(public payload: {
        [productCode: string]: ContractOP[];
    }) { }
}

/**
 * Reset admixture contracts store
 */
export class AdtContractsResetAction implements Action {
    readonly type = AdtContractActionTypes.RESET;

    constructor() { }
}

export type AdtContractActions =
    | FetchBalanceContracts
    | AdtContractsResetAction
    | LoadProductContracts
    | LoadContractSelectedAction
    | LoadContractBalancesAction;
